export const COMPANY_SETTINGS_ID = 1;
export const USER_MANAGEMENT_ID = 2;
export const SUBSCRIPTION_ID = 3;
